import React from "react";
import {Select} from "antd";
//local
import {Tag} from "components/Tag";
import {Info} from "components/Info";
import {color} from "constants/color.consts";
import {IconChevronDownMini} from "components/icons";
import {hasValue} from "helpers/helper";
import cn from "classnames";

const MiniSelect = ({
  list,
  onChange,
  defaultValue,
  isFilledDropdownValues,
  highlightIfEmpty,
  selectedValue,
  label,
  tinyLabel,
  fullWidthDropdownLabel,
  itemColor = color.black,
  borderColor = color.lightGray,
  informationText,
  uppercaseLabel,
  boldLabel,
  prefixLabel,
  itemAsObject,
  addClass,
  addDropdownClass,
  colorValues = {},
  disabled,
}) => {
  const {Option} = Select;

  const SelectLabel = () => (
    <label
      className={cn("mini-select_label", {
        __uppercase: !!uppercaseLabel,
        __bold: !!boldLabel,
        __tiny: !!tinyLabel,
        "ml-1": !prefixLabel,
        "mr-1": prefixLabel,
      })}
    >
      {label}
    </label>
  );

  const options = () =>
    list.map((item, i) => {
      const itemValue = itemAsObject ? item.value : item;
      const textColor = colorValues[itemValue] ?? itemColor;

      return (
        <Option
          key={itemAsObject ? `${item.value}${i}` : `${item}${i}`}
          value={itemValue}
        >
          <Tag
            text={itemAsObject ? item.label : item}
            color={textColor}
            borderColor={borderColor}
            suffixIcon={
              <IconChevronDownMini
                color={
                  selectedValue === item.value || !isFilledDropdownValues
                    ? itemColor
                    : color.white
                }
              />
            }
            noBackground={!isFilledDropdownValues}
            needTranslation
          />
        </Option>
      );
    });

  return (
    <div className={cn("mini-select_wrapper", {[addClass]: !!addClass})}>
      {hasValue(label) && prefixLabel && <SelectLabel />}
      <Select
        className={cn("mini-select_select", {
          "bg-yellow": highlightIfEmpty,
        })}
        bordered={false}
        onChange={onChange}
        suffixIcon={null}
        defaultValue={defaultValue}
        value={selectedValue}
        disabled={disabled}
        popupClassName={cn("mini-select_dropdown", {
          [addDropdownClass]: !!addDropdownClass,
          "full-width-labels": !!fullWidthDropdownLabel,
        })}
      >
        {options()}
      </Select>
      {hasValue(label) && !prefixLabel && <SelectLabel />}
      {informationText && (
        <Info
          tooltip={informationText}
          centerText
          addClass={label && !prefixLabel ? "ml-2" : "ml-1"}
        />
      )}
    </div>
  );
};

export default MiniSelect;
